/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_SubtitleInputs */

const en_fc_tut_subtitle = /** @type {(inputs: Fc_Tut_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten short steps from a blank project to an exported MP4. If you have used Premiere Pro before, most of this will feel like home.`)
};

/**
* | output |
* | --- |
* | "Ten short steps from a blank project to an exported MP4. If you have used Premiere Pro before, most of this will feel like home." |
*
* @param {Fc_Tut_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_subtitle = /** @type {((inputs?: Fc_Tut_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_subtitle(inputs)
});
export { fc_tut_subtitle as "fc.tut.subtitle" }